<div class="modal-header">
  <h4 class="modal-title">{{ "data.send_confirm_email" | translate }}</h4>
  <div class="btn-group btn-group-sm">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="copyEmail()"
      title="{{ 'COMMON.COPY' | translate }}"
    >
      <i class="fa fa-copy"></i>
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary ml-2"
      aria-label="Close"
      (click)="closeModal()"
    >
      <i class="fa fa-close"></i>
    </button>
  </div>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="main-card mb-3 card">
        <div class="card-body">
          <h3 class="card-title">{{ "data.providers" | translate }}</h3>
          <div class="row">
            <div
              class="col-12 col-md-6"
              *ngFor="let item of providerContacts; let index = index"
            >
              <div class="custom-checkbox custom-control form-check">
                <!-- <input
                  class="form-check-input"
                  id="cmd_{{ index }}"
                  type="checkbox"
                  name="cmd_{{ index }}"
                  [(ngModel)]="item.isChecked"
                  [checked]="item.isChecked"
                /> -->
                <label class="label-checkbox100" for="cmd_{{ index }}">
                  {{ item?.email }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="main-card mb-3 card">
        <div class="card-body">
          <h3 class="card-title">
            {{ "data.Transport_companies" | translate }}
          </h3>
          <div class="row">
            <div
              class="col-12 col-md-6"
              *ngFor="let item of transContacts; let index = index"
            >
              <div class="custom-checkbox custom-control form-check">
                <!-- <input
                  class="form-check-input"
                  id="trans_{{ index }}"
                  type="checkbox"
                  name="trans_{{ index }}"
                  [(ngModel)]="item.isChecked"
                  [checked]="item.isChecked"
                /> -->
                <label class="label-checkbox100" for="trans_{{ index }}">
                  {{ item?.email }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="p-3" #emailContent [innerHTML]="emailHtml"></div>
</div>
